<script setup lang="ts">
import { faArrowDownToBracket } from '@fortawesome/pro-light-svg-icons'

defineProps<{
  disabled?: boolean
  layout?: 'reading' | 'list'
}>()

defineEmits<{
  (e: 'click'): void
}>()
</script>

<template>
  <button
    id="open-download-modal-btn"
    class="no-underline !w-fit"
    :class="[
      buttonVariants.favorite.base({ intent: 'filled', layout }),
      disabled && 'opacity-50 cursor-not-allowed',
    ]"
    aria-label="Åpne nedlastingsvindu"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <Icon :icon="faArrowDownToBracket" />
    <span class="font-medium text-sm hidden nav:block">Last ned</span>
  </button>
</template>
